import './style.css';
import { useNavigate } from 'react-router-dom';
import Icon404 from '@shared/icons/Icon404';

const NoMatch = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/home');
  };

  return (
    <div className="no-match">
      <div className="no-match__container">
        <div className="no-match__image">
          <Icon404 />
        </div>
        <div className="no-match__info">
          <div className="no-match__info__message">
            Sorry, the page you were looking for was not found.
          </div>
          <div className="no-match__info__button">
            <button onClick={goToHome} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoMatch;
